import { FC } from 'react'

import { Settings } from '@/components/layout/settings/layout'
import SettingsTitle from '@/components/layout/settings/title'
import useObject from '@/hooks/useObject'
import LogoUploadCard from '@/pages/settings/branding/LogoUploadCard'
import { retrieveBranding } from '@/thunks/branding/retrieve'
import fadeIn from '@/util/fadeIn'

const SettingsBranding: FC = () => {
  const [branding] = useObject(retrieveBranding, {})

  return (
    <Settings>
      <SettingsTitle title="Branding" />
      {branding && (
        <div className={fadeIn(true, 'max-w-xl')}>
          <LogoUploadCard branding={branding} />
        </div>
      )}
    </Settings>
  )
}

export default SettingsBranding
